import React, { useState, useEffect } from "react";
import "../styles/Booking.css";

function PopupForm({ isOpen, onClose }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    date: "",
    timeslot: "",
    purpose: "",
  });

  const [services, setServices] = useState([]);
  const [timeslots, setTimeslots] = useState([]);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loadingSlots, setLoadingSlots] = useState(false);

  useEffect(() => {
    fetch(process.env.REACT_APP_SERVICES_API)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setServices(data.services);
      })
      .catch((err) => console.error("Service fetch error:", err));
  }, []);

  useEffect(() => {
    if (!form.date) {
      setTimeslots([]);
      return;
    }

    setLoadingSlots(true);

    fetch(process.env.REACT_APP_SLOTS_API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ date: form.date }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setTimeslots(data.slots || []);
          if (form.timeslot && !data.slots.includes(form.timeslot)) {
            setForm((prev) => ({ ...prev, timeslot: "" }));
          }
        } else {
          setTimeslots([]);
        }
      })
      .catch(() => setTimeslots([]))
      .finally(() => setLoadingSlots(false));
  }, [form.date]);

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
    return () => (document.body.style.overflow = "auto");
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const res = await fetch(process.env.REACT_APP_BOOKING_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();

      if (data.success) {
        alert("Booking successful!");
        setForm({
          name: "",
          email: "",
          phone: "",
          service: "",
          date: "",
          timeslot: "",
          purpose: "",
        });
        setTimeslots([]);
        onClose();
      } else {
        alert(data.message || "Booking failed");
      }
    } catch {
      alert("Something went wrong");
    } finally {
      setIsSubmitting(false);
    }
  };

  const getTodayDate = () =>
    new Date().toISOString().split("T")[0];

  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <div className="popup-image">
          <img src="/images/home/banner/popup.jpg" alt="Booking" />
        </div>

        <div className="popup-form">
          <button className="close-btn" onClick={onClose}>✕</button>
          <h2 className="form-heading">Book Your Service</h2>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Your Name</label>
              <input type="text" name="name" value={form.name} onChange={handleChange} required />
            </div>

            <div className="form-group">
              <label>Email Address</label>
              <input type="email" name="email" value={form.email} onChange={handleChange} required />
            </div>

            <div className="form-group">
              <label>Mobile Number</label>
              <input type="tel" name="phone" value={form.phone} onChange={handleChange} required />
            </div>

            <div className="form-group">
              <label>Select Service</label>
              <select name="service" value={form.service} onChange={handleChange} required>
                <option value="">Select Service</option>
                {services.map((s) => (
                  <option key={s.id} value={s.title}>{s.title}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Select Date</label>
              <input type="date" name="date" min={getTodayDate()} value={form.date} onChange={handleChange} required />
            </div>

            <div className="form-group">
              <label>Select Time Slot</label>
              <select
                name="timeslot"
                value={form.timeslot}
                onChange={handleChange}
                disabled={loadingSlots || timeslots.length === 0}
                required
              >
                <option value="">
                  {loadingSlots ? "Loading..." : "Select Time Slot"}
                </option>
                {timeslots.map((slot, i) => (
                  <option key={i} value={slot}>{slot}</option>
                ))}
              </select>
            </div>

           <div className="form-group purpose-group">
        <label>Purpose</label>
        <textarea
          name="purpose"
          placeholder="Purpose of booking"
          value={form.purpose}
          onChange={handleChange}
          rows="3"
        />
      </div>

            <button type="submit" className="submit-btn" disabled={isSubmitting}>
              {isSubmitting ? "Submitting..." : "Book Appointment"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default PopupForm;
